exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-filter-summary{background-color:#f2f2f2;font-size:smaller}.bi-filter-summary .bi-filter-summary-desc{font-weight:bolder;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports
